import React, { useEffect } from "react";

import useGetEnvironmentFeature from "@/app/utils/environment";
import { setFeatureConfig } from "@/redux/slices/featureFlagSlice";
import { useAppDispatch } from "@/redux/store";

type FeatureInitializerProps = {
  children: React.ReactNode;
};

const FeatureInitializer = (
  props: FeatureInitializerProps,
): React.JSX.Element => {
  const { children } = props;

  const dispatch = useAppDispatch();
  const featureConfig = useGetEnvironmentFeature();

  useEffect(() => {
    dispatch(setFeatureConfig(featureConfig));
  }, [featureConfig, dispatch]);

  return <>{children}</>;
};

export default FeatureInitializer;
